<template>
  <div id="createCompany">
    <form @submit.prevent="create">
      <div class="column column-50">
        <div class="box">
          <h2>{{ $t('company-info') }}</h2>

          <div class="form-input">
            <label for="name">{{ $t('company-name') }}</label><!--
            --><input type="text"
                   :placeholder="$t('company-name')"
                   id="name"
                   v-model="newCompany.name"
                   @focus="companyExists = false"
                   @blur="checkCompanyByName"/>
          </div>

          <div class="form-input">
            <label for="coc">{{ $t('coc-number') }}</label><!--
            --><input type="text"
                      :placeholder="$t('coc-number')"
                      id="coc"
                      v-model="newCompany.coc"
                      @focus="companyExists = false"
                      @blur="checkCompanyByCoc"/>
          </div>

          <div class="form-input">
            <label for="vat">{{ $t('vat-number') }}</label><!--
            --><input type="text"
                      :placeholder="$t('vat-number')"
                      id="vat"
                      v-model="newCompany.vat"/>
          </div>

          <div class="form-input">
            <label for="website">{{ $t('website') }}</label><!--
            --><input type="text"
                      :placeholder="$t('website')"
                      id="website"
                      v-model="newCompany.website"/>
          </div>

          <input type="submit" class="button button-lg" value="Aanmaken"/>

        </div>
      </div><!--

      --><div class="column column-50">
        <div class="box">
          <h2>{{ $t('contact-info') }}</h2>

          <div class="form-input">
            <label for="email">{{ $t('email') }}</label><!--
            --><input type="text"
                      :placeholder="$t('email')"
                      id="email"
                      v-model="newCompany.email"/>
          </div>

          <div class="form-input">
            <label for="phone">{{ $t('phone') }}</label><!--
            --><input type="text"
                      :placeholder="$t('phone')"
                      id="phone"
                      v-model="newCompany.phone"/>
          </div>

          <div class="form-input">
            <label for="zipcode">{{ $t('zipcode') }}</label><!--
            --><input type="text"
                      :placeholder="$t('zipcode')"
                      id="zipcode"
                      v-model="newCompany.address.zipcode"
                      @change="lookupZipcode"/>
          </div>

          <div class="form-input">
            <label for="number">{{ $t('housenumber') }}</label><!--
            --><input type="text"
                      :placeholder="$t('housenumber')"
                      id="number"
                      v-model="newCompany.address.number"
                      @change="lookupZipcode"/>
          </div>

          <div class="form-input">
            <label for="street">{{ $t('street') }}</label><!--
            --><input type="text"
                      :placeholder="$t('street')"
                      id="street"
                      :class="{ loading: zipcodeLoading }"
                      :disabled="zipcodeLoading"
                      v-model="newCompany.address.street"/>
          </div>

          <div class="form-input">
            <label for="city">{{ $t('city') }}</label><!--
            --><input type="text"
                      :placeholder="$t('city')"
                      id="city"
                      :class="{ loading: zipcodeLoading }"
                      :disabled="zipcodeLoading"
                      v-model="newCompany.address.city"/>
          </div>

          <div class="form-input">
            <label for="state">{{ $t('state') }}</label><!--
            --><input type="text"
                      :placeholder="$t('state')"
                      id="state"
                      :class="{ loading: zipcodeLoading }"
                      :disabled="zipcodeLoading"
                      v-model="newCompany.address.state"/>
          </div>

        </div>
      </div>
    </form>
    
    <talking-bird :text="$parent.pickRandom($t('bird-company-exists'), { company: this.newCompany.name })"
                  :buttons="existsButtons"
                  v-if="companyExists"></talking-bird>

    <talking-bird :text="$parent.pickRandom($t('bird-coc'), { company: this.newCompany.name })"
                  :buttons="undoCocButtons"
                  v-if="cocFilled && !companyExists"></talking-bird>
  </div>
</template>

<script>
import { Companies, Zipcode, KvK } from '@/services/api/ApiRoutes';

export default {
  name: 'CreateCompany',

  data() {
    // Set page title
    this.$parent.title.heading = `${this.$t('company')} ${this.$t('create')}`;
    this.$parent.title.subheading = this.$parent.pickRandom(this.$t('company-create-tagline'));

    return {
      newCompany: {
        address: {
          street: '',
          city: '',
          state: '',
        },
      },
      companyExists: false,
      zipcodeLoading: false,
      cocFilled: false,
      companies: {
        error: null,
        loaded: false,
        data: [],
      },
      existsButtons: [
        {
          label: 'Bedrijf bekijken',
          handler: () => {
            const win = window.open(`/#/companies/${this.companyExists}`, '_blank');
            win.focus();
          },
        },
      ],
      undoCocButtons: [
        {
          label: 'Ongedaan maken',
          handler: () => {
            this.cocFilled = false;

            this.newCompany.coc = '';
            this.newCompany.address.street = '';
            this.newCompany.address.number = '';
            this.newCompany.address.zipcode = '';
            this.newCompany.address.state = '';
            this.newCompany.address.city = '';
            this.newCompany.website = '';
          },
        },
      ],
    };
  },

  methods: {
    create() {
      Companies.create(this.newCompany).then(() => {
      });
    },

    checkCompanyByName() {
      console.log("GET", this.newCompany.name);
      Companies.get({ name: this.newCompany.name }).then((companies) => {
        if (companies.length > 0) {
          console.log("Got company", companies);
          this.companyExists = companies[0]._id;
          return false;
        }

        return KvK.get({ 'tradeNames.businessName': this.newCompany.name });
      }).then((companies) => {
        if (!companies) return;

        if (companies.length > 0) {
          const company = companies[0];
          const companyAddress = company.addresses[0];

          this.cocFilled = true;

          this.newCompany.coc = company.kvkNumber;
          this.newCompany.address.street = companyAddress.street;
          this.newCompany.address.number = companyAddress.houseNumber;
          this.newCompany.address.zipcode = companyAddress.postalCode;
          this.newCompany.address.city = companyAddress.city;
          this.newCompany.website = company.websites[0];

          this.lookupZipcode();
        }
      });
    },

    checkCompanyByCoc() {
      Companies.get({ coc: this.newCompany.coc }).then((companies) => {
        if (companies.length > 0) this.companyExists = companies[0]._id;
      });
    },

    lookupZipcode() {
      if (!this.newCompany.address.zipcode || !this.newCompany.address.number) return;
      this.zipcodeLoading = true;

      Zipcode.get({
        postcode: this.newCompany.address.zipcode,
        number: this.newCompany.address.number,
      }).then((addresses) => {
        this.zipcodeLoading = false;
        if (addresses.length === 0) return;

        const address = addresses[0];
        this.newCompany.address.street = address.street;
        this.newCompany.address.city = address.city.label;
        this.newCompany.address.state = address.province.label;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/companies/CreateCompany.vue